<script>
    import Select from 'svelte-select'
    import {getProductTypes} from "../firestore";
    import {toArray, map} from "rxjs/operators";

    export let modifiedEquipment;
    export let equipment;

    let materialTypeItems = [];

    getProductTypes().pipe(
        map(product => ({value: product.name, label: product.name})),
        toArray()
    ).subscribe(products => {
        materialTypeItems = products
    })

    let selectedValue = {value: modifiedEquipment.infos.type, label: modifiedEquipment.infos.type};

    $: watchValue(selectedValue);

    function watchValue(_selectedValue) {
        if (_selectedValue) modifiedEquipment.infos.type = _selectedValue.value;
    }
</script>

<div class="card">
    <div class="card-body">
        <div class="card-head">
            <h2 class="card-title">Equipment edition</h2>
            <p class="card-subtitle">#{equipment.id}</p>
        </div>

        <div class="padding-top" style="width: 60%">
            <h5>Display name</h5>
            <input class="card-highlight" bind:value={modifiedEquipment.infos.name}/>

            <h5 class="padding-top">Display units</h5>
            <input class="card-highlight" bind:value={modifiedEquipment.infos.display_units}/>

            <h5 class="padding-top">Material type</h5>
            <Select items={materialTypeItems} bind:selectedValue={selectedValue} isClearable={false}/>
        </div>
    </div>
</div>